<template>
  <div class="lc-audio"
       v-if="!isOldAndroid">
    <div class="lc-audio__player lc-container">
      <div class="lc-audio__control">
        <button class="mdc-button mdc-button--icon"
          @click="play"
          v-if="paused && !complete">
          <i class="material-icons">play_arrow</i>
        </button>

        <button class="mdc-button mdc-button--icon"
          @click="replay"
          v-if="complete">
          <i class="material-icons">replay</i>
        </button>

        <button class="mdc-button mdc-button--icon"
          @click="pause"
          v-if="playing && !complete">
          <i class="material-icons">pause</i>
        </button>
      </div>

      <a class="lc-audio__playback-time"
        @click="setPosition">
        <span class="lc-audio__playback-time-indicator" :style="progressStyle"></span>
      </a>

      <div class="lc-audio__time">
        <span class="lc-audio__time-current">
          {{ current }}
        </span> |
        <span class="lc-audio__time-total">
          {{ duration }}
        </span>
      </div>

    </div>

    <audio ref="audiofile" :src="file" preload="auto" style="display: none;">
    </audio>
  </div>
  <div class="lc-container"
       v-else>
    <audio ref="audiofile" controls :src="file" preload="auto">
    </audio>
  </div>
</template>

<script>
  import Mobile from '@/mixins/Mobile';

  const convertTimeHHMMSS = (val) => {
    const hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
    return (hhmmss.indexOf('00:') === 0) ? hhmmss.substr(3) : hhmmss;
  };

  export default {
    name: 'lc-audio',

    mixins: [
      Mobile,
    ],

    props: [
      'audio',
      'autoPlay',
    ],

    data() {
      return {
        audioEl: null,
        loaded: false,
        playing: false,
        paused: true,
        complete: false,
        progressStyle: '',
        currentTime: 0,
        totalDuration: 0,
      };
    },

    computed: {
      file() {
        return this.audio.audio_url || this.audio.url;
      },

      current() {
        return this.audioEl ? convertTimeHHMMSS(this.currentTime) : '00:00';
      },

      duration() {
        return this.audioEl ? convertTimeHHMMSS(this.totalDuration) : '00:00';
      },
    },

    mounted() {
      this.audioEl = this.$refs.audiofile;

      this.audioEl.addEventListener('loadeddata', this.handleLoaded);
      this.audioEl.addEventListener('timeupdate', this.handlePlayer);
      this.audioEl.addEventListener('pause', this.handlePlayPause);
      this.audioEl.addEventListener('play', this.handlePlayPause);
    },

    beforeDestroy() {
      this.audioEl.removeEventListener('loadeddata', this.handleLoaded);
      this.audioEl.removeEventListener('timeupdate', this.handlePlayer);
      this.audioEl.removeEventListener('pause', this.handlePlayPause);
      this.audioEl.removeEventListener('play', this.handlePlayPause);
    },

    methods: {
      play() {
        if (this.playing) {
          return;
        }

        this.audioEl.play();

        this.paused = false;
        this.playing = true;
      },

      replay() {
        this.audioEl.currentTime = 0;
        this.complete = false;
        this.play();
      },

      pause() {
        if (this.paused) {
          return;
        }

        this.audioEl.pause();

        this.paused = true;
        this.playing = false;
      },

      setPosition(e) {
        const tag = e.target;

        if (!this.playing) return;

        const pos = tag.getBoundingClientRect();
        const seekPos = (e.clientX - pos.left) / pos.width;

        this.audioEl.currentTime = parseInt(this.audioEl.duration * seekPos, 10);
      },

      handleLoaded() {
        if (this.audioEl.readyState >= 2) {
          if (this.autoPlay) {
            this.play();
          }

          this.loaded = true;
          this.totalDuration = parseInt(this.audioEl.duration, 10);
        } else {
          throw new Error('Failed to load sound file');
        }
      },

      handlePlayer() {
        const currentTime = parseInt(this.audioEl.currentTime, 10);
        const percentage = parseInt((currentTime / this.totalDuration) * 100, 10);

        this.progressStyle = `width: ${percentage}%;`;
        this.currentTime = currentTime;

        if (this.currentTime === this.totalDuration) {
          this.complete = true;
          this.playing = false;
          this.paused = true;
        }
      },

      handlePlayPause(e) {
        if (e.type === 'pause' && this.paused === false && this.playing === false) {
          this.progressStyle = 'width: 0%;';
          this.currentTime = '00:00';
        }
      },
    },

    created() {
      window.pauseMedia = () => {
        this.pause();
      };
    },
  };
</script>

<style lang="scss">
  .lc-audio {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.07);
  }

  .lc-audio__player {
    display: flex;
    align-items: center;

    padding: 0;
  }

  .lc-audio__control,
  .lc-audio__time {
    padding: 14px;
  }

  .lc-audio__playback-time {
    height: 4px;

    position: relative;

    flex-grow: 1;

    background-color: #eee;
    cursor: pointer;
  }

  .lc-audio__playback-time-indicator {
    height: 4px;

    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;

    display: block;

    background-color: #e0e0e0;
  }
</style>



// WEBPACK FOOTER //
// src/components/LcAudio.vue